import { clientPortalRequest } from "./clientPortalFetch";
import { buildClientQuery } from "./clientPortalFetch";

function iamBase(clientViewId) {
  return `/views/${encodeURIComponent(clientViewId)}/iam`;
}

export function getClientViewIamSummary(clientViewId) {
  return clientPortalRequest(`${iamBase(clientViewId)}/summary`);
}

export function listClientViewIamUsers(clientViewId, params = {}) {
  return clientPortalRequest(`${iamBase(clientViewId)}/users${buildClientQuery(params)}`);
}

export function inviteClientViewIamUser(clientViewId, body) {
  return clientPortalRequest(`${iamBase(clientViewId)}/users/invite`, {
    method: "POST",
    body: JSON.stringify(body),
  });
}

export function patchClientViewIamUserStatus(clientViewId, clientUserId, body) {
  return clientPortalRequest(
    `${iamBase(clientViewId)}/users/${encodeURIComponent(clientUserId)}/status`,
    {
      method: "PATCH",
      body: JSON.stringify(body),
    }
  );
}

export function updateClientViewIamAssignment(clientViewId, assignmentId, body) {
  return clientPortalRequest(
    `${iamBase(clientViewId)}/assignments/${encodeURIComponent(assignmentId)}`,
    {
      method: "PATCH",
      body: JSON.stringify(body),
    }
  );
}

export function listClientViewIamRoles(clientViewId) {
  return clientPortalRequest(`${iamBase(clientViewId)}/roles`);
}

export function listClientViewIamPermissions(clientViewId) {
  return clientPortalRequest(`${iamBase(clientViewId)}/permissions`);
}

export function createClientViewIamRole(clientViewId, body) {
  return clientPortalRequest(`${iamBase(clientViewId)}/roles`, {
    method: "POST",
    body: JSON.stringify(body),
  });
}

export function updateClientViewIamRole(clientViewId, iamRoleId, body) {
  return clientPortalRequest(`${iamBase(clientViewId)}/roles/${encodeURIComponent(iamRoleId)}`, {
    method: "PATCH",
    body: JSON.stringify(body),
  });
}

export function deleteClientViewIamRole(clientViewId, iamRoleId) {
  return clientPortalRequest(`${iamBase(clientViewId)}/roles/${encodeURIComponent(iamRoleId)}`, {
    method: "DELETE",
  });
}

export function listClientViewIamAuditLog(clientViewId, params = {}) {
  return clientPortalRequest(`${iamBase(clientViewId)}/audit-log${buildClientQuery(params)}`);
}

export function resetClientViewIamUserPassword(clientViewId, clientUserId, body = {}) {
  return clientPortalRequest(
    `${iamBase(clientViewId)}/users/${encodeURIComponent(clientUserId)}/password-reset`,
    {
      method: "POST",
      body: JSON.stringify(body),
    }
  );
}

export function getClientViewIamUserLoginHistory(clientViewId, clientUserId, params = {}) {
  return clientPortalRequest(
    `${iamBase(clientViewId)}/users/${encodeURIComponent(clientUserId)}/login-history${buildClientQuery(params)}`
  );
}

export function updateClientViewIamUserRole(clientViewId, clientUserId, body) {
  return clientPortalRequest(
    `${iamBase(clientViewId)}/users/${encodeURIComponent(clientUserId)}/role`,
    {
      method: "PATCH",
      body: JSON.stringify(body),
    }
  );
}
